import { takeLatest } from "redux-saga/effects";

import chatActionCreators from "../../actions/chat";
import sagasUtils from "../../../utils/sagas.utils";

export function* watchSyncPropertyRooms() {
  yield takeLatest(chatActionCreators.syncPropertyRooms.toString(), sagasUtils.syncChatRooms);
}
